import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function HumanTrafficking() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Anti-human trafficking policy"} />
      <MarkdownBlock markdown={TextBlocks.HUMAN_TRAFFICKING_POLICY_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
